import gql from 'graphql-tag';

// Comments plan 3b: a signed upload address for a file on a comment.
export default gql`
mutation commentFileUpload($object: CommentFileUploadInput!) {
  commentFileUpload(object: $object) {
    ok
    error
    reason
    upload
    url
  }
}
`;
